import { Component, Input, OnInit } from '@angular/core';
import {
  DataCardI,
  DataListConfigI,
} from 'src/app/core/interfaces/card.interface';

@Component({
  selector: 'app-data-list',
  templateUrl: './data-list.component.html',
  styleUrls: ['./data-list.component.scss'],
})
export class DataListComponent implements OnInit {
  @Input() config: DataListConfigI;
  @Input() data: any[];
  constructor() {}

  ngOnInit() {}
}
